var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('legal-document',{attrs:{"title":"Согласие на обработку персональных данных","type":"personal-data-agreement"}})}
var staticRenderFns = []

export { render, staticRenderFns }